import { _ } from "~/i18n";
import { createPremiumIcon, node } from "~/util/dom";
import { openPremiumOnboarding } from "~/util/user-note";

interface INotePlaceholderPremium {
	onClick?: () => void;
}

// tlacitko - upravit / pridat poznamku
export function createNotePlaceholderPremium({
	onClick = () => {},
}: INotePlaceholderPremium) {
	const container = node("div", { className: "note-placeholder-premium" });
	const link = node("a", { href: "" });

	container.textContent = _("mymap.folders.premium");
	link.append(createPremiumIcon(), document.createTextNode(_("profile.premiumPromo.text2")));
	container.append(link);

	link.setAttribute("data-log-action", "MyMapsNotes_premiumPurchase_show");
	link.addEventListener("click", event => {
		event.stopPropagation();
		event.preventDefault();
		// vlastni onclick
		onClick();
		// pustime onboarding
		openPremiumOnboarding();
	});

	return container;
}
